<template>
  <el-dialog title="上游报价" :visible.sync="dialogIsShow" width="550px" :close-on-click-modal="false" ref="dialog"
    append-to-body>
    <div class="dia_body">
      <el-form label-width="140px" label-position="left" style="" v-if="jobUpPrice">
         <el-form-item label="编号：" size="small">
          {{ jobUpPrice.BatchNum}}
        </el-form-item>
        <el-form-item label="人工费单价：" size="small">
          {{ jobUpPrice.ManHourPrice }}
        </el-form-item>
        <el-form-item label="人工费数量：" size="small">
          {{ jobUpPrice.ManHourCount }}
        </el-form-item>
        <el-form-item label="人工费合计：" size="small">
          {{ jobUpPrice.ManHourAmount }}
        </el-form-item>

        <el-form-item label="交通费单价：" size="small">
          {{ jobUpPrice.TrafficPrice }}
        </el-form-item>
        <el-form-item label="交通费数量：" size="small">
          {{ jobUpPrice.TrafficCount }}
        </el-form-item>
        <el-form-item label="交通费合计：" size="small">
          {{ jobUpPrice.TrafficAmount }}
        </el-form-item>

        <el-form-item label="材料费单价：" size="small">
          {{ jobUpPrice.MateriaPrice }}
        </el-form-item>
        <el-form-item label="材料费数量：" size="small">
          {{ jobUpPrice.MateriaCount }}
        </el-form-item>
        <el-form-item label="材料费合计：" size="small">
          {{ jobUpPrice.MateriaAmount }}
        </el-form-item>

        <el-form-item label=" 其他费用单价：" size="small">
          {{ jobUpPrice.OtherPrice }}
        </el-form-item>
        <el-form-item label="其他费用数量：" size="small">
          {{ jobUpPrice.OtherCount }}
        </el-form-item>
        <el-form-item label="其他费用合计：" size="small">
          {{ jobUpPrice.OtherAmount }}
        </el-form-item>

        <el-form-item label="计费类型：" size="small">
          {{ jobUpPrice.BillType == 0 ? "按天" : "整包" }}
        </el-form-item>

        <el-form-item label="总费用：" size="small">
          {{ jobUpPrice.TotalAmount }}
        </el-form-item>

        <el-form-item label="预付款：" size="small" v-if="jobUpPrice.BillType == 1">
          {{ jobUpPrice.PrepayAmount }}
        </el-form-item>
        <el-form-item label="预付百分比：" size="small">
          {{ jobUpPrice.PrepayAmountPercent }}%
        </el-form-item>
        <el-form-item label="结束支付：" size="small" v-if="jobUpPrice.BillType == 1">
          {{ jobUpPrice.EndAmount }}
        </el-form-item>
        <el-form-item label="结束支付百分比：" size="small">
          {{ jobUpPrice.EndAmountPercent }}%
        </el-form-item>
        <el-form-item label="备注：" size="small">
          <div v-html="jobUpPrice.OfferRemark"> </div>
        </el-form-item>

        <el-form-item label="报价客服：" size="small">
          {{ jobUpPrice.AdminUserName }}
        </el-form-item>
        <el-form-item label="报价时间：" size="small">
          {{ jobUpPrice.CreateTime }}
        </el-form-item>
        <el-form-item label="状态：" size="small">
          {{ jobUpPrice.AuditStatusName }}
        </el-form-item>

        <el-form-item label="审核人：" size="small" v-if="jobUpPrice.AuditStatus==1||jobUpPrice.AuditStatus==2">
          {{ jobUpPrice.AuditAdminUserName }}
        </el-form-item>
         <el-form-item label="审核备注：" size="small" v-if="jobUpPrice.AuditStatus==1||jobUpPrice.AuditStatus==2">
          {{ jobUpPrice.Remark }}
        </el-form-item>

      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" size="small" @click="dialogIsShow = false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogIsShow: false,
      jobId: 0,
      isProjectJob: 0,
      jobUpPrice: null
    };
  },
  created() {

  },

  computed: {

  },
  methods: {
    openDia(jobUpPrice) {
      this.jobUpPrice = jobUpPrice;
      this.dialogIsShow = true;
        if(jobUpPrice.OfferRemark) {
        jobUpPrice.OfferRemark=jobUpPrice.OfferRemark.replace(/\r/g,'<br/>');
      }
      console.log("this.jobUpPrice:" + JSON.stringify(this.jobUpPrice));
    },


  }
};
</script>

<style scoped lang="scss">
.dia_body {
  padding: 0 15px;
  // border: 1px solid red;

  .el-form-item {
    margin-bottom: 5px !important;
  }
}
</style>